import styled from 'styled-components'
import { Spacings, Devices } from '@styles'

const Grid = styled.div`
	display: grid;
	grid-template-columns: 1fr;
	gap: ${Spacings.SPACING_3B};

	@media ${Devices.tablet} {
		grid-template-columns: repeat(2, 1fr);
		gap: ${Spacings.SPACING_4B};
	}

	@media ${Devices.laptop} {
		grid-template-columns: repeat(3, 1fr);
	}
`

export default Grid
